import React, { useState, useEffect } from 'react';
import './WhatsAppButton.css';

const DEFAULT_PHONE_NUMBER = '447347949022';
const DEFAULT_MESSAGE = 'Hello Cardplot Support, I would like to make an inquiry.';

export const WhatsAppButton = ({
  phoneNumber = process.env.REACT_APP_WHATSAPP_NUMBER || DEFAULT_PHONE_NUMBER,
  message = process.env.REACT_APP_WHATSAPP_MESSAGE || DEFAULT_MESSAGE,
  customUrl = process.env.REACT_APP_WHATSAPP_URL,
}) => {
  const [hasTawk, setHasTawk] = useState(false);
  const [isChatMaximized, setIsChatMaximized] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Normalize phone number (strip non-digits)
  const safePhone = phoneNumber || DEFAULT_PHONE_NUMBER;
  const cleanNumber = String(safePhone).replace(/[^0-9]/g, '');

  const href =
    customUrl ||
    `https://wa.me/${cleanNumber}${
      message ? `?text=${encodeURIComponent(message)}` : ''
    }`;

  useEffect(() => {
    // Check if Tawk widget is present in the DOM
    const checkTawk = () => {
      const tawkPresent =
        typeof window !== 'undefined' &&
        Boolean(document.querySelector('iframe[title*="chat" i], [id*="tawk"], .tawk-min-container'));
      setHasTawk(tawkPresent);
    };

    checkTawk();
    const interval = setInterval(checkTawk, 1500);

    // Attach Tawk event listeners if available
    if (typeof window !== 'undefined') {
      window.Tawk_API = window.Tawk_API || {};

      const prevOnLoaded = window.Tawk_API.onLoad;
      window.Tawk_API.onLoad = function () {
        setHasTawk(true);
        if (typeof prevOnLoaded === 'function') prevOnLoaded();
      };

      const prevOnChatMaximized = window.Tawk_API.onChatMaximized;
      window.Tawk_API.onChatMaximized = function () {
        setIsChatMaximized(true);
        if (typeof prevOnChatMaximized === 'function') prevOnChatMaximized();
      };

      const prevOnChatMinimized = window.Tawk_API.onChatMinimized;
      window.Tawk_API.onChatMinimized = function () {
        setIsChatMaximized(false);
        if (typeof prevOnChatMinimized === 'function') prevOnChatMinimized();
      };

      const prevOnChatHidden = window.Tawk_API.onChatHidden;
      window.Tawk_API.onChatHidden = function () {
        setHasTawk(false);
        if (typeof prevOnChatHidden === 'function') prevOnChatHidden();
      };
    }

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`whatsapp-float-container ${
        hasTawk ? 'with-tawk' : 'standalone'
      } ${isChatMaximized ? 'chat-maximized' : ''}`}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span className={`whatsapp-tooltip ${showTooltip ? 'visible' : ''}`}>
        Chat on WhatsApp
      </span>

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float-btn"
        aria-label="Chat with us on WhatsApp"
        title="Chat on WhatsApp"
      >
        <span className="whatsapp-pulse-ring" aria-hidden="true" />
        <svg
          className="whatsapp-icon"
          viewBox="0 0 24 24"
          width="30"
          height="30"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.746.953 3.71 1.456 5.711 1.457h.004c6.554 0 11.89-5.335 11.893-11.893a11.82 11.82 0 00-3.487-8.414z" />
        </svg>
      </a>
    </div>
  );
};

export default WhatsAppButton;
